import { REQUIRED_CREDITS } from '../constants/credits';

const en = {
  inputType: 'Input type:',
  uploadPDF: 'PDF',
  comicDescription: 'Describe comic',
  comicDescriptionPlaceholder:
    'A curious elephant learns to fly with the help of its jungle friends.',
  comicDescriptionErrorMessage:
    'Description must be at least 10 characters long. ☝️',
  color: 'Color:',
  colorVariant: 'Select Color Variant',
  generatingDialog: 'Generating dialog ...',
  generatePDF: 'Generate PDF',
  generatingPDF: 'Generating PDF ...',
  generatedPDF: 'Generated PDF',
  message: 'Message',
  language: 'I want the comic in:',
  languageSerbian: 'Serbian',
  languageSlovenian: 'Slovene',
  languageEnglish: 'English',
  languageSpanish: 'Spanish',
  languageFrench: 'French',
  languageRussian: 'Russian',
  languageItalian: 'Italian',
  languageChinese: 'Chinese',
  languageTurkish: 'Turkish',
  languageHungarian: 'Hungarian',
  languagePortuguese: 'Portuguese',
  page: 'Page:',
  editProfile: 'Edit profile',
  purchaseTokens: 'Purchase tokens',
  transactions: 'Transactions',
  help: 'Help',
  transactionHistory: 'Your token transaction history',
  couldNotLoadTransactions: 'Could not load transactions.',
  noTransactions: 'No transactions yet.',
  transactionDate: 'Date',
  transactionSource: 'Source',
  transactionAmount: 'Amount',
  transactionStatus: 'Status',
  rowsPerPage: 'Rows per page',
  previous: 'Previous',
  next: 'Next',
  pageOf: 'Page __PAGE__ of __TOTAL__',
  statusCompleted: 'Completed',
  sourcePurchase: 'Purchase',
  sourceCoupon: 'Coupon',
  sourceRefund: 'Refund',
  sourceDailyGift: 'Daily gift',
  sourceScicomic: 'SciComic',
  sourceCite: 'Cite',
  helpGetStartedTitle: 'Getting started',
  helpGetStartedStep1:
    'Choose whether you want to upload a PDF or describe a story idea.',
  helpGetStartedStep2:
    'Select the language and number of pages before generating dialog.',
  helpGetStartedStep3:
    'Review the generated text, adjust messages if needed, then generate the final PDF.',
  helpWritingTitle: 'Writing better prompts',
  helpWritingTip1:
    'Keep the story short, clear, and focused on one main idea or scene.',
  helpWritingTip2:
    'Mention the tone, characters, and setting if you want a more specific result.',
  helpWritingTip3:
    'Use manual message editing to polish speech bubbles before export.',
  helpGenerationTitle: 'Generation tips',
  helpGenerationTip1:
    'Generating dialog and generating a comic spend tokens, so check your balance first.',
  helpGenerationTip2:
    'For one-page comics, keep dialogue concise so each bubble stays readable.',
  helpGenerationTip3:
    'If something looks off, regenerate the dialog or tweak the text before creating the PDF.',
  helpContactTitle: 'Need more help?',
  helpContactDescription:
    'If you run into an issue or need assistance with your account or tokens, contact our support team.',
  helpGotIt: 'Got it',
  helpVersion: 'SciComic v1.0',
  selectTokenPackage: 'Select a token package',
  individual: 'Individual',
  professional: 'Professional',
  closePurchaseModal: 'Close token purchase',
  stripeConfigurationError: 'Token purchase is currently unavailable.',
  redeemCode: 'Redeem code',
  enterCode: 'Enter your code',
  redeem: 'Redeem',
  redeeming: 'Redeeming...',
  cancel: 'Cancel',
  codeRedeemed: 'Code redeemed successfully.',
  codeAlreadyUsed: 'This code has already been used.',
  codeNotFound: 'Code not found.',
  failedToRedeem: 'Failed to redeem code.',
  wizardStep: 'Step',
  wizardSource: 'Source and settings',
  wizardScript: 'Script',
  wizardImages: 'Panel images',
  wizardVisualDesign: 'Ready to generate',
  wizardSourceDescription:
    'Add your comic source and review the selected language.',
  wizardScriptDescription:
    'Review the introduction, key facts, and conclusion before continuing.',
  wizardImagesDescription:
    'Optionally upload images or describe what should be generated for each panel.',
  wizardVisualDescription:
    'Choose the comic background color and readable text color.',
  sourceQuestion: 'What do you want to turn into a comic?',
  dropPdf: 'Drag your PDF here or click to',
  browsePdf: 'choose a file',
  continue: 'Continue',
  comicType: 'Comic type',
  onePage: 'One page',
  classicFourPanelTemplate: 'Classic four-panel comic',
  classicFourPanelTemplateDescription:
    'A clean one-page layout with a title, four equal images, and captions below each image.',
  templateTitlePlacement: 'Title appears at the top of the page.',
  templateImagePlacement: 'Images are arranged in a 2 by 2 grid.',
  templateTextPlacement: 'Text is placed below each image, not over it.',
  fourPanelStory: 'Four-panel story',
  verificationScoreLabel: 'Reliability __SCORE__/100',
  verificationDetailsTitle: 'Script accuracy check',
  verificationDetailsDescription:
    "SciComic's verification loop checked this generated story against the original PDF text.",
  verificationDetailSource:
    'Checked that the numbers and key figures in the comic actually come from the original PDF source.',
  verificationDetailSourceTooltip:
    "Numbers, statistics, and abbreviations in the script are compared against the original source text to catch any figure the comic states that isn't in the source.",
  verificationDetailClaims:
    'The key claims across all four frames were reviewed to stay faithful to the source.',
  verificationDetailClaimsTooltip:
    "AI checks whether the claims in all four panels stay true to the source material, and that the comic doesn't state anything the source doesn't support.",
  verificationDetailLanguage:
    'The script was checked against the selected language.',
  verificationDetailLanguageTooltip:
    'Checks whether the whole text is consistently written in the selected language.',
  verificationScoreUnavailableLabel: 'Reliability not available',
  verificationDetailUnavailable: 'Not verified',
  verificationDetailUnavailableTooltip:
    'This check could not be completed for this script, so it is left out of the overall reliability score rather than counted as a pass.',
  comicTitle: 'Comic title',
  comicTitlePlaceholder: 'Enter a title for this comic...',
  defaultComicTitle: 'SciComic',
  panelIntroduction: 'Introduction',
  panelKeyFact: 'Key fact',
  panelExplanation: 'Explanation',
  panelConclusion: 'Conclusion',
  panelTextPlaceholder: 'Write one short, factual sentence...',
  panelImage: 'Panel image',
  uploadPanelImage: 'Upload image',
  removePanelImage: 'Remove',
  generatedPanelImage: 'Generated image',
  panelImagePrompt: 'Image prompt',
  panelImagePromptPlaceholder: 'Describe the image you want for this panel...',
  panelImagePromptDisabled: "Image uploaded, prompt won't be used.",
  panelImageOptionalNote:
    'Uploaded images have priority. If there is no uploaded image, SciComic uses your prompt; if the prompt is empty, it generates the image from the panel story.',
  previousStep: 'Previous step',
  createScript: 'Create script',
  workflowError: 'Something went wrong. Please try again.',
  frames: 'frames',
  frame: 'Frame',
  emptyFrame: 'Empty frame',
  sentence: 'Sentence',
  length: 'Length',
  keep: 'Keep',
  shorter: 'Shorter',
  longer: 'Longer',
  complexity: 'Complexity',
  simpler: 'Simpler',
  scientific: 'More scientific',
  tone: 'Tone',
  toneProfessional: 'Professional',
  toneFriendly: 'Friendly',
  toneFunny: 'Funny',
  rewriteInstruction: 'Regeneration instruction',
  regenerateSourceDescription: 'Comic source description',
  selectedPdf: 'Selected PDF',
  noPdfSelected: 'No PDF selected',
  changePdf: 'Change PDF',
  changePdfDescription:
    'If you change the PDF, you need to recreate the script from the new file.',
  rewriteInstructionPlaceholder: 'Describe what should change in this frame...',
  regenerateFrame: 'Regenerate frame',
  comicBackgroundColor: 'Comic background color',
  comicBackgroundColorDescription:
    'Set the page background behind the title, images, and text.',
  comicTextColor: 'Text color',
  comicTextColorDescription:
    'Choose the title and caption color. Use the suggestion for better contrast.',
  comicFonts: 'Comic fonts',
  comicFontsDescription:
    'Choose separate fonts for the title and the text below images. Font changes are free.',
  comicTitleFont: 'Title font',
  comicBodyFont: 'Text below images font',
  hexColor: 'HEX color',
  useSuggestedTextColor: 'Use suggested text color',
  storyteller: 'Storyteller',
  logout: 'Logout',
  spendingCreditsDialog: `Generating the story will cost you ${REQUIRED_CREDITS.GENERATE_DIALOG} token.`,
  imageCountText: {
    1: 'one image',
    2: 'two images',
    3: 'three images',
    4: 'four images',
  },
  tokenCountText: {
    1: 'one token',
    2: 'two tokens',
    3: 'three tokens',
    4: 'four tokens',
  },
  imageStepCreditNotice:
    'SciComic will currently generate __IMAGE_COUNT__. This will cost __TOKEN_COUNT__ only when you click final generation.',
  imageStepFreeNotice:
    'All images are already available. No additional tokens will be spent for them.',
  regenerateFrameCreditNotice:
    'Regenerating this frame will spend __CREDITS__ token.',
  notEnoughCreditsDialog: `You need at least ${REQUIRED_CREDITS.GENERATE_DIALOG} credit to generate a comic dialog.`,
  notEnoughCreditsComic:
    'You need at least __TOKEN_COUNT__ to generate __IMAGE_COUNT__.',
  disclaimer:
    'SciComic may make mistakes. Please verify important information.',
};

export default en;
